export const TOUR_STORAGE_KEYS = {
  WELCOME_SEEN: 'b2b_tour_welcome_seen',
  HOME_COMPLETED: 'b2b_tour_home_completed',
  RESULTS_COMPLETED: 'b2b_tour_results_completed',
  SEE_MORE_TARIFS_SEEN: 'b2b_tour_see_more_tarifs_seen',
  VIP_SOLICITATION_SEEN: 'b2b_tour_vip_solicitation_seen',
  REFINE_SEARCH_SEEN: 'b2b_tour_refine_search_seen',
  TOUR_RESERVATION_SEEN: 'b2b_tour_reservation_seen',
} as const

export const tourStorage = {
  isWelcomeSeen: () =>
    localStorage.getItem(TOUR_STORAGE_KEYS.WELCOME_SEEN) === 'true',
  setWelcomeSeen: () =>
    localStorage.setItem(TOUR_STORAGE_KEYS.WELCOME_SEEN, 'true'),
  isTarifsSeen: () =>
    localStorage.getItem(TOUR_STORAGE_KEYS.SEE_MORE_TARIFS_SEEN) === 'true',
  setTarifsSeen: () =>
    localStorage.setItem(TOUR_STORAGE_KEYS.SEE_MORE_TARIFS_SEEN, 'true'),
  isResultsSeen: () =>
    localStorage.getItem(TOUR_STORAGE_KEYS.RESULTS_COMPLETED) === 'true',
  setResultsSeen: () =>
    localStorage.setItem(TOUR_STORAGE_KEYS.RESULTS_COMPLETED, 'true'),
  isRefineSearchTourSeen: () =>
    localStorage.getItem(TOUR_STORAGE_KEYS.REFINE_SEARCH_SEEN) === 'true',
  setRefineSearchTourSeen: () =>
    localStorage.setItem(TOUR_STORAGE_KEYS.REFINE_SEARCH_SEEN, 'true'),
  isVipSolicitationSeen: () =>
    localStorage.getItem(TOUR_STORAGE_KEYS.VIP_SOLICITATION_SEEN) === 'true',
  setVipSolicitationSeen: () =>
    localStorage.setItem(TOUR_STORAGE_KEYS.VIP_SOLICITATION_SEEN, 'true'),
  isTourReservationSeen: () =>
    localStorage.getItem(TOUR_STORAGE_KEYS.TOUR_RESERVATION_SEEN) === 'true',
  setTourReservationSeen: () =>
    localStorage.setItem(TOUR_STORAGE_KEYS.TOUR_RESERVATION_SEEN, 'true'),

  isTourSeen: (tourKey: keyof typeof TOUR_STORAGE_KEYS) =>
    localStorage.getItem(TOUR_STORAGE_KEYS[tourKey]) === 'true',

  setTourSeen: (tourKey: keyof typeof TOUR_STORAGE_KEYS) =>
    localStorage.setItem(TOUR_STORAGE_KEYS[tourKey], 'true'),
  SeenAllTours: () => {
    Object.values(TOUR_STORAGE_KEYS).forEach(key => {
      localStorage.setItem(key, 'true')
    })
  },
  resetAllTours: () => {
    Object.values(TOUR_STORAGE_KEYS).forEach(key => {
      localStorage.removeItem(key)
    })
  },
}
